<template>
	<div class="">
		<!-- <headers bg="#000" color="#fff"></headers> -->
		<headers></headers>
		<div class="pt-container" >
			<div class="row">
				<div class="col-md-6 flex flex-column justify-content-between align-items-center ">
					<div class="ftr-2 ftw600">
						{{problemList[problemIndex]}}
					</div>
					<div class="d-flex align-items-end fs-d-n">
						<div class="forStudy-tab bg-theme me-2" v-for="(item,index) in problemList"
						@click="problemIndex = index"
						:class="problemIndex==index?'':'forStudy-tab-select forStudy-bg'" ></div>
					</div>
				</div>
				<div class="col-md fs-m-t" style="max-height: 65vh;overflow-y: scroll;">
					<div class="border-gray br12 wid-fit py-2 px-4 text-center ftw600 fs-60 mb-3 clickAct"
					@click="selectItem(index)"
					 v-for="(item,index) in answerList[problemIndex].list">
						<div v-if="problemIndex!=4&&problemIndex!=5">
							 {{item.name}}
						</div>
						<div v-else>
							{{item}}
						</div>
					</div>
					<button type="button" class="btn br12 btn-outline-dark ftw600 fs-60 wid-fit"
					 @click="selectItem()">
						{{$t('forStudy.skipQuestion')}}
					 </button>
					<div class="flex mt-3 text-underline clickAct flex justify-content-center cl-info fs-60" @click="toTeacher()">
						<!-- 自行挑選導師 -->
						{{$t('forStudy.chooseMentor')}}
					</div>  
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				problemIndex:0,
				problemList:[this.$t('forStudy.studyFor'),this.$t('forStudy.whatExtent'),this.$t('forStudy.motherTongue'),this.$t('forStudy.mentorLevel'),this.$t('forStudy.budget'),this.$t('forStudy.classTime')],
				answerList:[
					{
						key:'class',
						list:[]
					},
					{
						key:'degree',
						list:[],
					},
					{
						key:'language',
						list:[]
					},
					{
						key:'teacherType',
						list:[]
					},
					{
						key:'motherTongue',
						list:['80-109','116-146','153-182','189-218','218+']
					},
					{
						key:'time',
						list:['12:00'+this.$t('forClassIndex.brfore'),'12:00 - 18:00','18:00 - 24:00']
					}
				],
				course_id:0,
				course_classify_id:0,
				price_min: '', //课程价格区间
				price_max: '',
				nation_id: 0, //国家id
				week: '', //星期【英文星期名称，monday、tuesday、......】
				week_time_min: '', //星期时间区间 09:00
				week_time_max: '',
				language_id: 0, //语言id
				language_level_id: 0, //语言等级ID
				professor_level_id: 0, //教授级别ID
				special_educational_experience_id: 0, //特殊教育经验ID
				education_background_id: 0, //学历id
				search_price:'',
			}
		},
		async created(){
			let arr = await this.informationIntegration(['language','languageLevel', 'travelLocation', 'professorLevel'])
			
			this.answerList[2].list = arr.list.language.list
			this.answerList[3].list = arr.list.language.list
			this.classifyList()
			this.getCourseList()
		},
		methods:{
			classifyList(){
				this.$http.api('course/classifyList',{
					// includeCourse:1
				}).then(res=>{
					this.answerList[1].list = res.list
					
				})
			},
			getCourseList() {
				this.$http.api('course/courseList', {
			
				}).then(res => {
					this.answerList[0].list = res.list
				})
			},
			
			selectItem(index){
				console.log("----index",index);
				// 记录选择的值
				if(this.problemIndex==0){
					this.course_id = this.answerList[0].list[0].id
				}else if(this.problemIndex==4){
					this.search_price = index
					if (index === 0) {
						this.price_min = 80
						this.price_max = 109
					} else if (index == 1) {
						this.price_min = 116
						this.price_max = 146
					} else if (index == 2) {
						this.price_min = 153
						this.price_max = 182
					} else if (index == 3) {
						this.price_min = 189
						this.price_max = 218
					} else if (index == 4) {
						this.price_min = 218
						this.price_max = ''
					}
				}else if(this.problemIndex==1){
					this.course_classify_id = this.answerList[1].list[0].id
				}else if(this.problemIndex==2){
					this.language_id = this.answerList[2].list[0].id
				}else if(this.problemIndex==5){
					if(index==0){
						this.week_time_min='00:00'
						this.week_time_max = '12:00'
					}else if(index==1){
						this.week_time_min='12:00'
						this.week_time_max = '18:00'
					}else if(index==2){
						this.week_time_min='18:00'
						this.week_time_max = '24:00'
					}
					
					// this.week = index
					// console.log("---week",this.week);
				}
				
				// else if(this.problemIndex==2){
				// 	this.nation_id = this.answerList[2].list[index].id
				// }else if(this.problemIndex==3){
				// 	this.week = index
				// 	console.log("---week",this.week);
				// }else if(this.problemIndex==4){
				// 	this.professor_level_id = this.answerList[4].list[index].id
				// }else if(this.problemIndex==5){
				// 	this.language_level_id = this.answerList[5].list[index].id
				// }
				
				
				if(this.problemIndex>=this.problemList.length-1){
					if(!this.checkLogin()){
						this.$router.push('/login');
						return
					}
					this.$router.push(`/classIndex?id=${this.course_id}&price_min=${this.price_min}&price_max=${this.price_max}&nation_id=${this.nation_id}&week=${this.week}
					&week_time_max=${this.week_time_max}&week_time_min=${this.week_time_min}&language_id=${this.language_id}&search_price=${this.search_price}`);
				}else{
					// 选择完答案后自动跳到下一个问题
					this.problemIndex++
					this.text = this.problemList[this.problemIndex]
				}
				
			},
			toTeacher(){
				if(!this.checkLogin()){
					this.$router.push('/login');
					return
				}
				this.$router.push('/classIndex');
			}
		}
	}
</script>

<style scoped>
	.forStudy-bg{
		background-color: #C9C9C8;
	}
	.forStudy-tab{
		width: 24px;
		height: 24px;
	}
	.forStudy-tab-select{
		width: 15px;
		height: 15px;
	}
	.fs-60{
		width: 60%;
	}
	.fs-h{
		height: 200px;
	}
	@media (max-width:575.98px) {
		.p-6 {
			padding-left: 1.5rem !important;
			padding-right: 1.5rem !important;
		}
		.fs-60{
			width: 100% !important;
		}
		.fs-m-t{
			margin-top: 1.5rem;
		}
		.fs-d-n{
			display: none !important;
		}
		.fs-h{
			height: auto !important;
		}
		.pt-container {
			margin: auto;
			width: 100%;
			padding-left: 1.5rem !important;
			padding-right: 1.5rem !important;
		}
	}
	@media (min-width: 576px) {
		.pt-container {
			margin: auto;
			width: 580px;
			margin-top: 8%;
		}
	
	}
	
	@media (min-width: 768px) {
		.pt-container {
			margin: auto;
			width: 900px;
			margin-top: 8%;
		}
	}
	
	@media (min-width: 1200px) {
		.pt-container {
			margin: auto;
			width: 1100px;
			margin-top: 8%;
		}
	}
	
	@media (min-width: 1400px) {
		.pt-container {
			margin: auto;
			width: 1300px;
			margin-top: 8%;
		}
	}
</style>